module.exports = __webpack_public_path__ + "static/img/zidongjieting.938c899.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/zidongjieting.png
// module id = g7Zq
// module chunks = 24